<template>
  <validation-observer ref="saveFormRef" #default="{ invalid }">
    <b-overlay :show="isLoading" rounded="sm">
      <b-form @submit.prevent="handleSaveData">
        <b-row>
          <b-col cols="12">
            <b-form-group label-for="certificateType">
              <template>
                Loại chứng chỉ <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Loại chứng chỉ"
                rules="required"
              >
                <v-select
                  v-model="dataSource.certificateType"
                  :options="certificateTypes"
                  :reduce="option => option.value"
                  :disabled="enableSelectType"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          
          <b-col cols="12">
            <b-form-group>
              <template>
                File <span class="text-danger">*</span>
              </template>
              <b-form-file
                ref="fileInput"
                multiple
                accept=".pdf, .docx, .doc"
                :placeholder="placeholder"
                no-file-name
                :reset="true"
              />
              <template #file-name>
                <span>{{ placeholder }}</span>
              </template>
            </b-form-group>
            
            <div v-if="uploadedFiles.length > 0" class="uploaded-files mt-2 mb-1">
              <p class="uploaded-files-title">Danh sách file đã tải lên:</p>
              <ul class="uploaded-files-list list-group">
                <li
                  v-for="file in uploadedFiles"
                  :key="file.mediaId"
                  class="uploaded-files-item list-group-item d-flex justify-content-between align-items-center"
                >
                  <div class="uploaded-file-info d-flex align-items-center">
                    <feather-icon icon="FileIcon" class="mr-2" />
                    <span
                      class="uploaded-file-name"
                      :title="'Bấm vào để tải về ' + file.name"
                      @click="onDownload(file.code)"
                    >
                      {{ file.name }}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </b-col>
          
          <b-col cols="12">
            <div class="float-left">
              <b-button
                type="submit"
                variant="primary"
                class="mr-1"
                :disabled="invalid"
              >
                Lưu
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </b-overlay>
  </validation-observer>
</template>

<script>
import {
  BForm,
  BButton,
  BRow,
  BCol,
  BFormGroup,
  BFormFile,
  BOverlay,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import { CERTIFICATE_TYPES } from '@/const/status'
import { getUser } from '@/auth/utils'
import api from './api'

export default {
  name: 'StudentFileSave',
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormFile,
    BOverlay,
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      certificateTypes: [],
      dataSource: {
        id: null,
        certificateType: null,
        studentId: null,
      },
      placeholder: 'Chọn file để tải ...',
      uploadedFiles: [],
      enableSelectType: false
    }
  },
  created() {
    this.certificateTypes = CERTIFICATE_TYPES
    this.dataSource.studentId = this.user.studentId
    
    if (this.data?.studentCertificateId) {
      this.enableSelectType = true
      this.dataSource.id = this.data.studentCertificateId
      this.dataSource.certificateType = this.data.studentCertificateType
      this.uploadedFiles = this.data.studentCertificateFiles || []
    }
  },
  methods: {
    async handleSaveData() {
      const valid = await this.$refs.saveFormRef.validate()
      if (valid) {
        this.isLoading = true
        try {
          const formData = new FormData()
          formData.append(
            'studentCertificate',
            new Blob([JSON.stringify(this.dataSource)], {
              type: 'application/json',
            })
          )
          
          const files = this.$refs.fileInput?.files
          if ( files?.length > 0 ) {
            Array.from(files)
              .forEach(file => {
                formData.append('files', file)
              })
          }
          
          const response = await api.createStudentCertificate(formData)
          if ( response ) {
            const {
              isSuccessful,
              message
            } = response
            this.showToast(message, isSuccessful ? 'CheckIcon' : 'XCircleIcon', isSuccessful ? 'success' : 'danger')
            if ( isSuccessful ) {
              this.$bvModal.hide('files-save')
              this.resetForm()
              this.$emit('succeed')
            }
          }
        } catch ( e ) {
          this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
        } finally {
          this.isLoading = false
        }
      }
    },
    
    resetForm() {
      this.dataSource = {
        id: null,
        certificateType: null,
        studentId: this.user.studentId,
      }
      this.uploadedFiles = []
      this.placeholder = 'Chọn file để tải ...'
      if ( this.$refs.fileInput ) {
        this.$refs.fileInput.reset()
      }
      
      if ( this.$refs.saveFormRef ) {
        this.$refs.saveFormRef.reset()
      }
    },
    
    async onDownload(objectPath) {
      this.isLoading = true
      try {
        const res = await api.downloadDocument({ objectPath })
        if ( res ) {
          window.open(res, '_blank')
        }
      } catch ( e ) {
        this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
      } finally {
        this.isLoading = false
      }
    },
    
    showToast(title, icon, variant) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon,
          variant,
        },
      })
    },
    
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
  },
}
</script>

<style scoped>
</style>
